import { useState } from 'react';
import { RouterProvider } from 'react-router/dom';
import { AppProviders } from './providers';
import { createAppRouter } from './router';
import { ErrorBoundary } from './ErrorBoundary';

export function App() {
  const [router] = useState(createAppRouter);
  return (
    <ErrorBoundary>
      <AppProviders>
        <RouterProvider router={router} />
      </AppProviders>
    </ErrorBoundary>
  );
}
